import { render, staticRenderFns } from "./PlayerWebRtc.vue?vue&type=template&id=8581577e&scoped=true&lang=pug&"
import script from "./PlayerWebRtc.vue?vue&type=script&lang=js&"
export * from "./PlayerWebRtc.vue?vue&type=script&lang=js&"
import style0 from "./PlayerWebRtc.vue?vue&type=style&index=0&id=8581577e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8581577e",
  null
  
)

export default component.exports